// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2s9cv","productName":"Table_productName__3VyNs"};